import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgProfileVisits = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 52.86614 52.85276",
	...props,
	children: [/* @__PURE__ */ _jsx("title", { children: "ProfileVisit" }), /* @__PURE__ */ _jsx("path", {
		d: "M45.75305,38.88V44.1s-5.71,7.67-19.31,7.5c-13.61.17-19.33-7.5-19.33-7.5V38.88c2-3.61,13.35-6.9,13.35-6.9V26.23a16.23936,16.23936,0,0,1-2.99-7.53l-.74-4.23V10.96a9.71,9.71,0,0,1,19.42,0v3.51l-.7,4.24a16.58709,16.58709,0,0,1-3.04,7.52v5.75S43.77307,35.27,45.75305,38.88Z",
		style: {
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: "2.5px"
		}
	})]
});
export default SvgProfileVisits;
